import React from 'react';
/* Helpers */
import { INTERNAL_THEME } from '../../../helpers/constants';
import { getItemFromLS } from '../../../helpers/localStorage';
import { addThousandSeparator, addThousandSeparatorNoParse, getMinMaxString } from '../../../helpers/utils';
/* Redux */
import { useSelector } from 'react-redux';
/* CSS */
import './style.css';

export const Footer = ({ 
  showDynamicParagraph = true,
  isSimulator = false,
  textToUse = null,
  useBold = false
}) => {
  const { amount, payment, numberOfInstallments, TAN, TAEG, others } = useSelector(state => state.currentSimulation);
  const internalTheme = useSelector(state => state.internalTheme);
  const isSpeedApp = useSelector(state => state.isSpeedApp);
  // TODO: Rivedere a seconda di come si deciderà di impostare il tema generale
  // TODO: Rivedere tutto utilizzando useReducer
  let title = null;
  let text = null;
  let copyright = null;

  const isSpeedAppText = isSpeedApp ? "Processo riservato solo ai titolari di SPID." : "";

  switch (internalTheme) {
    case INTERNAL_THEME.COMPASS_ONE_MINUTE_SIMULATOR: {
      title = "INFORMAZIONI TRASPARENTI";
      /*
      text = `
        Importo totale del credito ${addThousandSeparator(amount.current)}€.
        Importo totale dovuto ${getMinMaxString(amount.min, amount.max, { label: true, symbol: "€", numberOfDigitsAfterDecimalPoint: 2 })}.
        Modalità di rimborso con addebito diretto in conto (SDD). TAEG ${getMinMaxString(TAEG.min, TAEG.max, { label: true, symbol: "%", numberOfDigitsAfterDecimalPoint: 2 })}
        inclusivo di interessi al TAN fisso ${getMinMaxString(TAN.min, TAN.max, { label: true, symbol: "%", numberOfDigitsAfterDecimalPoint: 2 })};
        importo rata nell'intervallo tra ${addThousandSeparator(payment.min, 2)}€ (per durata pari a ${numberOfInstallments.min} mesi) e ${addThousandSeparator(payment.max, 2)}€ (per durata pari a ${addThousandSeparator(numberOfInstallments.max, 0)} mesi);
        spese di istruttoria pari a ${addThousandSeparator(others.administrationFees, 0)}€;
        commissioni di incasso e gestione pratica € ${window.USR_SM_CMP_GESTIONE_PRATICA} a rata;
        oneri fiscali applicati al contratto richiesti con 1° rata ${addThousandSeparator(others.stampDuty, 2)}€;
        oneri fiscali applicati alle comunicazioni periodiche di trasparenza ${addThousandSeparator(others.transparencyDuty)}€;
        spese di invio comunicazione periodica di trasparenza annuale € ${window.USR_SM_CMP_COMUNICAZIONE_PERIODICA_TRASPARENZA_ANNUALE} se cartacea (gratuita online).
        Durata totale del finanziamento: ${getMinMaxString(numberOfInstallments.min, numberOfInstallments.max, { label: true, symbol: "", numberOfDigitsAfterDecimalPoint: 0 })} mesi.
        Salvo approvazione di Compass Banca S.p.A.
        Documenti informativi sul sito compass.it. Condizioni economiche applicabili solo in caso di perfezionamento della richiesta online.
        L'esito definitivo viene comunicato entro il termine della giornata lavorativa successiva, rispetto al momento in cui è stata fornita la documentazione completa. Nel caso in cui questa venga fornita in un giorno festivo,sabato incluso, si considera come pervenuta il primo giorno lavorativo successivo. ${window.USR_SM_CMP_CLAUSOLA}
      `;
      */
      text = `
        Importo totale del credito ${addThousandSeparator(amount.current)}€.
        Importo totale dovuto ${getMinMaxString(amount.min, amount.max, { label: true, symbol: "€", numberOfDigitsAfterDecimalPoint: 2 })}.
        Modalità di rimborso con addebito diretto in conto (SDD). TAEG ${getMinMaxString(TAEG.min, TAEG.max, { label: true, symbol: "%", numberOfDigitsAfterDecimalPoint: 2 })}
        inclusivo di interessi al TAN fisso ${getMinMaxString(TAN.min, TAN.max, { label: true, symbol: "%", numberOfDigitsAfterDecimalPoint: 2 })};
        importo rata ${addThousandSeparator(payment.min, 2)}€ per durata pari a ${addThousandSeparator(numberOfInstallments.min, 0)} mesi;
        spese di istruttoria pari a ${addThousandSeparatorNoParse(others.administrationFees, 2)}€;
        commissioni di incasso e gestione pratica € ${window.USR_SM_CMP_GESTIONE_PRATICA} a rata;
        oneri fiscali applicati al contratto richiesti con 1° rata ${addThousandSeparator(others.stampDuty, 2)}€;
        oneri fiscali applicati alle comunicazioni periodiche di trasparenza ${addThousandSeparator(others.transparencyDuty)}€;
        spese di invio comunicazione periodica di trasparenza annuale € ${window.USR_SM_CMP_COMUNICAZIONE_PERIODICA_TRASPARENZA_ANNUALE} se cartacea (gratuita online).
        Durata totale del finanziamento: ${getMinMaxString(numberOfInstallments.min, numberOfInstallments.max, { label: true, symbol: "", numberOfDigitsAfterDecimalPoint: 0 })} mesi.
        Salvo approvazione di Compass Banca S.p.A. Documenti informativi in App, sul sito compass.it e presso le filiali compass.
        Condizioni economiche applicabili solo in caso di perfezionamento della richiesta online. Compilati tutti i dati richiesti, Compass comunicherà l’esito della valutazione entro 1 minuto dalla sottoscrizione del contratto da parte del cliente, salvo impedimenti tecnici.
        ${isSpeedAppText}
      `;
      copyright = {
        text: "©Compass Banca S.p.A., socio unico direzione e coordinamento Mediobanca S.p.A., Tutti i diritti riservati - Per i dati Societari ",
        companyData: {
          text: "clicca qui",
          redirect: "/dati-societari-compass-spa.html",
        }
      };
      break;
    }
    case INTERNAL_THEME.COMPASS_BASE_SIMULATOR:
    default: {
      title = "INFORMAZIONI TRASPARENTI";
      text = `Condizioni economiche applicabili solo in caso di perfezionamento via web della richiesta di Prestito Online. Importo totale del credito ${addThousandSeparator(amount.current)}€. Importo totale dovuto ${getMinMaxString(amount.min, amount.max, { label: true, symbol: "€", numberOfDigitsAfterDecimalPoint: 2 })}.Modalità di rimborso con addebito diretto in conto (SDD). TAEG ${getMinMaxString(TAEG.min, TAEG.max, { label: true, symbol: "%", numberOfDigitsAfterDecimalPoint: 2 })} inclusivo di interessi al TAN fisso ${getMinMaxString(TAN.min, TAN.max, { label: true, symbol: "%", numberOfDigitsAfterDecimalPoint: 2 })}; importo rata nell'intervallo tra ${addThousandSeparator(payment.min, 2)}€ (per durata pari a ${numberOfInstallments.min} mesi) e ${addThousandSeparator(payment.max, 2)}€ (per durata pari a ${addThousandSeparator(numberOfInstallments.max, 0)} mesi); spese di istruttoria da ${addThousandSeparatorNoParse(others.administrationFees, 2)}€ a ${addThousandSeparatorNoParse(others.administrationFeesMax, 2)}€; commissioni di incasso e gestione pratica da min ${window.USR_SM_CMP_GESTIONE_PRATICA_MIN}€ a max ${window.USR_SM_CMP_GESTIONE_PRATICA_MAX}€ a rata; oneri fiscali applicati al contratto richiesti con 1° rata da min ${addThousandSeparator(others.stampDuty, 2)}€ a max ${addThousandSeparator(others.stampDutyMax, 2)}€; oneri fiscali applicati alle comunicazioni periodiche di trasparenza ${addThousandSeparator(others.transparencyDuty)}€; spese di invio comunicazione periodica di trasparenza annuale € ${window.USR_SM_CMP_COMUNICAZIONE_PERIODICA_TRASPARENZA_ANNUALE} se cartacea (gratuita online). Durata totale del finanziamento: ${getMinMaxString(numberOfInstallments.min, numberOfInstallments.max, { label: true, symbol: "", numberOfDigitsAfterDecimalPoint: 0 })} mesi. ${useBold ? `<b>${window.USR_SM_CMP_CLAUSOLA_NEW}</b>` : window.USR_SM_CMP_CLAUSOLA_NEW} Salvo approvazione di Compass Banca S.p.A. Documenti informativi sul sito compass.it. L'esito definitivo viene comunicato entro il termine della giornata lavorativa successiva, rispetto al momento in cui è stata fornita la documentazione completa. Nel caso in cui questa venga fornita in un giorno festivo,sabato incluso, si considera come pervenuta il primo giorno lavorativo successivo.${isSpeedAppText && isSpeedAppText !== "" ? `<br/>${isSpeedAppText}` : ""}<br/>Questo sito è protetto da reCAPTCHA e si applicano la Privacy Policy e i Termini di servizio di Google`;
      copyright = {
        text: "©Compass Banca S.p.A., socio unico direzione e coordinamento Mediobanca S.p.A., Tutti i diritti riservati - Per i dati Societari ",
        companyData: {
          text: "clicca qui",
          redirect: "/dati-societari-compass-spa.html",
        }
      };
      break;
    }
  }
  
  return (
    <>
      <footer id="footer" className={`${ isSimulator ? "simulatore-footer-logo-rpp" : "" }`}>
    	  <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 footer-in-rpp">
              { showDynamicParagraph ? (
                <div className="footer-top-rpp">
                  <h3>{ title }</h3>
                  <p
                    dangerouslySetInnerHTML={{ 
                      __html: text
                    }}
                  >
                  </p>
                </div>
                ) : 
                null
              }
              {
                textToUse ?
                (
                  <div className="footer-copyright-rpp">
                    <p>
                      { textToUse }
                      <br/>
                      { "Questo sito è protetto da reCAPTCHA e si applicano la Privacy Policy e i Termini di servizio di Google." }
                    </p>
                  </div>
                )
                :
                (
                  <div className="footer-copyright-rpp">
                    { copyright.text } <a href={copyright.companyData.redirect}>{ copyright.companyData.text }</a>
                  </div>
                )
              }
            </div>
          </div>
        </div>
        <div className="clearfix"></div>
      </footer>
    </>
  );
}
